import { gql } from '@apollo/client';
import { categoryFragment } from '../fragments/category';
import { goalFragment } from '../fragments/goal';

export const getSingleGoalQuery = gql`
    ${goalFragment}
    ${categoryFragment}

    query GetSingleGoal($id: String!) {
        goal(id: $id) {
            ...GoalFields
            category {
                ...CategoryFields
            }
        }
    }
`;
